module.exports = __webpack_public_path__ + "static/media/Q_2_11.2e734da8.jpg";